import { render, staticRenderFns } from "./ModelIncomeSubItem.vue?vue&type=template&id=f0dcd670&scoped=true&"
import script from "./ModelIncomeSubItem.vue?vue&type=script&lang=js&"
export * from "./ModelIncomeSubItem.vue?vue&type=script&lang=js&"
import style0 from "./ModelIncomeSubItem.vue?vue&type=style&index=0&id=f0dcd670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dcd670",
  null
  
)

export default component.exports